export const getStartedProxyActions = state => state.proxyActions;
